import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import GridCard from '../../Components/GridCard'
import { getCodeSetLabelLookup } from '../../Functions/CodeSetFns'
import { useUserContext } from '../../Contexts/UserConfig'
import { Box } from '@mui/material'

function VesselCards({
  holdingView,
  vessels,
  samples,
  detailsActive,
}: {
  holdingView: boolean
  vessels?: any[]
  samples?: any[]
  detailsActive: boolean
}) {
  const navigate = useNavigate()
  const { loginConfig } = useUserContext()

  function onClickVessel(id: string) {
    return navigate('/stuart/sample/vessel/info/' + id)
  }
  function onClickSample(id: string) {
    return navigate('/stuart/sample/info/' + id)
  }

  if (holdingView) {
    return (
      <>
        {(vessels ?? []).map((item) => {

          if (detailsActive) {
            return (
              <GridCard
                aria-label={'Vessel Card'}
                onClick={() => onClickVessel(item.VesselID)}
                id={item.VesselID}
                size={4}
                title={item.VesselID}
                subtitle={getCodeSetLabelLookup(
                  loginConfig,
                  ['VesselTypeID'],
                  item.VesselType,
                )}
                attributes={[
                  '',
                  {
                    value: String(item.VesselChildren),
                    variant: 'subtitle2',
                    color: 'primary',
                  },
                ]}
              />
            )
          } else {
            return (
              <GridCard
                aria-label={'Vessel Card'}
                onClick={() => onClickVessel(item.VesselID)}
                id={item.VesselID}
                size={3}
                attributes={[
                  item.VesselID,
                  {
                    value: String(item.VesselChildren),
                    variant: 'subtitle2',
                    color: 'primary',
                  },
                ]}
              />
            )
          }
        })}
      </>
    )
  } else if (vessels && vessels.length) {
    return (
      <>
        {vessels.map((item) => {
          if (detailsActive) {
            return (
              <GridCard
                aria-label={'Vessel Card'}
                onClick={() => onClickVessel(item.VesselID)}
                id={item.VesselID}
                size={6}
                title={item.VesselID}
                subtitle={getCodeSetLabelLookup(
                  loginConfig,
                  ['VesselTypeID'],
                  item.VesselType,
                )}
                attributes={[
                  String(item.VesselChildren),
                  {
                    value: item.VesselPositionHuman!,
                    variant: 'subtitle2',
                    color: 'primary',
                  },
                ]}
              />
            )
          } else {
            return (
              <GridCard
                aria-label={'Vessel Card'}
                onClick={() => onClickVessel(item.VesselID)}
                id={item.VesselID}
                size={3}
                attributes={[
                  {
                    value: item.VesselPositionHuman!,
                    variant: 'subtitle2',
                    color: 'primary',
                  },
                  item.VesselID,
                ]}
              />
            )
          }
        })}
      </>
    )
  } else if (samples) {
    return (
      <>
        {samples.map((item) => {
          if (detailsActive) {
            return (
              <GridCard
                aria-label={'Vessel Card'}
                onClick={() => onClickSample(item.SampleID)}
                id={item.SampleID}
                size={6}
                title={item.SampleID}
                subtitle={item.LineName}
                attributes={[
                  item.Sex,
                  item.AnimalID,
                  {
                    value: item.SamplePositionHuman!,
                    variant: 'subtitle2',
                    color: 'primary',
                  },
                ]}
              />
            )
          } else {
            return (
              <GridCard
                aria-label={'Vessel Card'}
                onClick={() => onClickSample(item.SampleID)}
                id={item.SampleID}
                size={3}
                attributes={[
                  {
                    value: item.SamplePositionHuman!,
                    variant: 'subtitle2',
                    color: 'primary',
                  },
                  item.SampleID,
                ]}
              />
            )
          }
        })}
      </>
    )
  } else {
    return <Box>No Data</Box>
  }
}

export default VesselCards
